<template>
    <div class="payment-chart-table">
        <button
            class="btn btn-blue amortization-table-btn"
            @click="toggleAmortizationTable()">
            {{ AmortizationTableVisible ? "Close" : "View" }} Amortization Table
        </button>
        <div
            v-show="AmortizationTableVisible"
            class="table-responsive">
            <table
                v-for="(yearData, year) in amortizationBreakdown"
                :key="(yearData, year)"
                class="table"
                :class="{active: isActive[year]}">
                <thead>
                    <tr>
                        <th width="19%">
                            <label
                                class="table-trigger"
                                @click="toggleActive(year)">
                                <span class="lt4-ChevronRight"></span> {{ year }}
                            </label>
                        </th>
                        <th width="27%">
                            Interest Paid: <big>${{ currencyFilter(yearData[yearData.length-1].yearTotalInterest) }}</big>
                        </th>
                        <th width="27%">
                            Principal Paid: <big>${{ currencyFilter(yearData[yearData.length-1].yearTotalPrincipal) }}</big>
                        </th>
                        <th width="27%">
                            Ending Balance: <big>${{ currencyFilter(yearData[yearData.length-1].balance) }}</big>
                        </th>
                    </tr>
                </thead>
                <tbody class="active">
                    <tr
                        v-for="(monthData, index) in yearData"
                        :key="index">
                        <td>{{ monthData.namedMonth }}</td>
                        <td>${{ currencyFilter(monthData.interestPaid) }}</td>
                        <td>${{ currencyFilter(monthData.principal) }}</td>
                        <td>${{ currencyFilter(monthData.balance) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import Accounting from 'accounting';
    import AmortizationBreakdownHelper from '~/helpers/amortization-breakdown';

    export default {
        mixins: [Accounting],
        props: {
            showAmortizationTable: {
                default: true,
            },
            loanAmount: {
                default: 0,
            },
            loanTermInYears: {
                default: 0,
            },
            interestRate: {
                default: 0,
            },
        },
        data() {
            return {
                isActive: {},
                AmortizationTableVisible: this.showAmortizationTable,
                YearData: null,
            };
        },
        computed: {
            amortizationBreakdown() {
                return AmortizationBreakdownHelper.amortizationBreakdown(this.loanAmount, this.loanTermInYears, this.interestRate);
            },
        },
        methods: {
            toggleAmortizationTable() {
                this.AmortizationTableVisible = !this.AmortizationTableVisible;
            },
            toggleActive(year) {
                this.isActive[year] = !this.isActive[year];
            },
            currencyFilter(figure) {
                return Accounting.formatNumber(figure, { precision: 2 });
            },
        },
    };
</script>
<style lang="scss" src="../../assets/styles/amortization-breakdown-table.scss"></style>
